<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path fill="currentColor" d="M271 62l-159 188l-15 -1l-63 -89l15 -11l56 79l151 -178z" />
  </svg>
</template>
